<!-- Facebook Notifications -->
<div class="fnt">
  <!-- The notifications list around the ad, as a skeleton -->
  <span class="fnt-bar fnt-title"></span>
  <span class="fnt-tab" style="left: 206px"></span>
  <span class="fnt-tab" style="left: 239px"></span>
  <span class="fnt-tab" style="left: 272px"></span>
  <span class="fnt-bar fnt-section" style="top: 58px"></span>
  <span class="fnt-unread"></span>
  <span class="fnt-bar fnt-section" style="top: 274px"></span>
  <span class="fnt-bar fnt-section" style="top: 427px"></span>

  <div class="fnt-row" *ngFor="let top of skeletonRows" [style.top.px]="top">
    <span class="fnt-photo"><span class="fnt-badge"></span></span>
    <span class="fnt-line" style="top: 8px; width: 192px"></span>
    <span class="fnt-line" style="top: 21px; width: 150px"></span>
    <span class="fnt-line fnt-line-date" style="top: 34px; width: 27px"></span>
    <i class="bi bi-three-dots fnt-menu"></i>
  </div>

  <!-- The ad -->
  <a class="fnt-ad" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
    <span class="fnt-ad-photo">
      <img [src]="avatar" alt="" />
      <span class="fnt-ad-badge"><i class="bi bi-link-45deg"></i></span>
    </span>
    <span class="fnt-ad-copy">
      <span class="fnt-ad-text">Stranica <b>{{ pageName }}</b> ima nešto što bi vam se moglo svidjeti: "{{ headline }}"</span>
      <span class="fnt-ad-label">Oglas</span>
    </span>
    <i class="bi bi-three-dots fnt-menu"></i>
  </a>
</div>
